/**
 * Task detail page — renders the canonical Task Editor in edit mode.
 * Same UI as create; only difference is existing task is loaded and save updates.
 */

import { useParams } from 'react-router-dom';
import { UnifiedTaskEditor } from '@/features/tasks';

export function TaskDetailPage() {
  const { taskId } = useParams<{ taskId: string }>();

  if (!taskId) {
    return null;
  }

  return (
    <div className="h-full flex flex-col">
      <UnifiedTaskEditor mode="edit" taskId={taskId} />
    </div>
  );
}
